// extracted by mini-css-extract-plugin
export default {"statusMessage":"StatusMessage_statusMessage__+ZBzB"};